<template>
  <Layout style="background: #21343b">
    <h2 slot="title" class="text-center" style="color: white">{{ $t('inviteTeammates') }}</h2>
    <p slot="desc" class="desc text-center mb-0" v-html="$t('inviteTeammatesDesc')" />
    <v-form slot="content" ref="inviteWsForm" class="text-center mt-3" @submit.prevent="setInviteWs" lazy-validation>
      <v-container>
        <v-row>
          <v-col style="color: white; text-align: left !important" class="text-h6">Invite link</v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" class="pa-0">
            <v-switch v-model="showMagicLink" inset></v-switch>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-text-field
              dark
              color="white"
              type="text"
              v-model="wsMagicLink"
              :loading="isMagicLinkLoading"
              readonly
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col style="text-align: left !important">
            <span style="color: #96a7af; font-size: 12px">
              Share this secret link to invite people to this workspace. To reset this link click
              <u @click="setMagicLink(true)" style="cursor: pointer">here</u>
              .
            </span>
          </v-col>
          <v-col cols="auto" class="mt-2">
            <v-btn small class="link_btn" @click="copy(wsMagicLink)" :disabled="!showMagicLink || isMagicLinkLoading">
              {{ isMobile() ? 'Share' : 'Copy' }} Link
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="color: white; text-align: left !important" class="text-h6">Email Invitation</v-col>
        </v-row>
        <v-row v-for="n in count" :key="n">
          <v-col class="pt-0 pb-0 mt-3">
            <v-text-field
              dark
              color="white"
              type="email"
              outlined
              dense
              :ref="`email${n - 1}`"
              :placeholder="$t('emailAddress')"
              :rules="[rules.email]"
              hide-details="auto"
              v-model="email[n - 1]"
              @keyup="checkVal(n - 1, $refs[`email${n - 1}`][0].hasError)"
              @blur="checkVal(n - 1, $refs[`email${n - 1}`][0].hasError)"
            />
          </v-col>
        </v-row>
        <v-row v-if="count <= max">
          <v-col class="pt-0 pb-0 mt-5 text-center">
            <v-btn text @click="addField">
              <v-icon large color="#666">mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0 mt-5">
            <v-btn
              block
              elevation="0"
              height="40"
              :disabled="!isBtnAble || isLoading"
              :loading="isLoading"
              :class="'btn-' + (isBtnAble || isLoading ? 'able' : 'disable')"
              id="continue"
              @click="setInviteWs"
            >
              {{ $t('continue') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Onboarding'
import { fill } from 'lodash'
import { isNull, regExpTest, format, isMobile } from '@/common/lib/strLib'
import firebase from 'firebase/app'
import { setInviteWs, setUserFunnel, getInviteUrl, setMagicLink, setWsUpdate } from '@/services/api'
import { copy } from '@/common/common'
import { mapGetters } from 'vuex'
// import InputEmail from '@/views/workspace/component/InputEmail'
import Toast from '@/views/meeting/component/Toast'

export default {
  name: 'InviteWorkspace',
  components: {
    // InputEmail,
    Layout,
  },
  props: ['passedWsId', 'passedWsName', 'passedWsDomain', 'passedWsLogo'],
  computed: {
    rules() {
      let vm = this

      return {
        // required: (value, type) => !isNull(value) || vm.$t('msgEnter' + type.charAt(0).toUpperCase() + type.slice(1)),
        email: (value) =>
          isNull(value) || (!isNull(value) && regExpTest('EMAIL', value)) || vm.$t('msgCheckEmailFormat'),
      }
    },
    ...mapGetters(['userInfo']),
  },
  data: () => ({
    count: 1,
    max: 20,
    email: [''],
    valChkArray: [],
    isBtnAble: false,
    isLoading: false,
    showMsg: false,
    errorCode: '',
    errorMessage: '',
    showMagicLink: false,
    wsMagicLink: '',
    isMagicLinkLoading: false,
  }),
  watch: {
    showMagicLink() {
      this.setMagicLink()
    },
  },
  created() {
    // if (!this.passedWsId) this.$router.replace({ name: 'Meeting' })
    this.valChkArray = fill(Array(1), true)
    this.isBtnAble = !this.valChkArray.includes(false)
  },
  mounted() {
    this.showMagicLink = true
  },
  methods: {
    isMobile() {
      return isMobile()
    },
    checkVal(index, result) {
      this.valChkArray.splice(index, 1, !result)
      this.isBtnAble = !this.valChkArray.includes(false)
    },
    addField() {
      this.count++
      this.valChkArray.push(true)
      this.isBtnAble = !this.valChkArray.includes(false)
    },
    async setInviteWs() {
      this.isLoading = true
      this.errorCode = ''
      this.errorMessage = ''
      this.showMsg = false

      let userEmail
      if (!this.$refs.inviteWsForm.validate()) return false

      try {
        userEmail = Array.from(new Set(this.email)).filter((item) => item !== '')
        if (userEmail.length > 0) {
          // 초대 API
          let inviteResult = await setInviteWs(this, this.passedWsId, this.$store.getters.userName, userEmail)
          // 리턴 받아온 정보 중 미가입 회원의 email에 로그인 링크 전달
          // 로그인 처리는 하지 않고, 쿼리를 전달받아 처리되도록 처리
          for (let email of inviteResult.nonMembers) {
            await firebase.auth().sendSignInLinkToEmail(email, {
              url: location.origin + '/signup?passedEmail=' + email + '&passedWsId=' + this.passedWsId,
              handleCodeInApp: true,
            })
          }
        }
        let inviteCntStr = userEmail.length.toString()
        this.$router.replace({
          name: 'CompleteWorkspace',
          params: { passedType: 'invite', inviteCnt: inviteCntStr, passedWsDomain: this.passedWsDomain },
        })
      } catch (error) {
        this.errorCode = typeof error.response !== 'undefined' ? error.response.data : error.message

        this.errorMessage = this.$t('msg' + this.errorCode.charAt(0).toUpperCase() + this.errorCode.slice(1))

        console.log(this.errorCode, this.errorMessage)

        this.showMsg = true
      } finally {
        if (userEmail && userEmail !== null && userEmail.length > 0) {
          await this.checkFunnel()
          for (let i = 0; i < userEmail.length; i++) {
            this.$store.dispatch('setFirebaseLog', {
              eventName: 'invite_member',
              eventParam: {
                name: 'invite_member',
              },
            })
          }
        }
        this.isLoading = false
      }
    },
    async checkFunnel() {
      try {
        const funnel = this.userInfo.funnel
        if (!funnel || funnel === '' || funnel === 'evaluator') {
          let result = await setUserFunnel(this, 'beginner')
          this.$store.commit('setUserInfo', result)
          this.$store.dispatch('setFirebaseLog', {
            eventName: 'funnel_beginner',
            eventParam: {
              createdAt: Date.now(),
              methodType: 'member_invite',
            },
          })
        }
      } catch (e) {
        console.log()
      }
    },
    async setMagicLink(isReset = false) {
      this.isMagicLinkLoading = true

      let params = {
        wsMagicLinkEnabled: this.showMagicLink,
      }

      if (this.showMagicLink || isReset) {
        params.wsMagicLinkUrl = await this.createMagicLink()
        this.wsMagicLink = params.wsMagicLinkUrl
      } else if (!this.showMagicLink) {
        this.wsMagicLink = ''
      }

      let result = await setWsUpdate(this, this.passedWsId, params)
      await this.$store.dispatch('getUserWsList')
      const selectedWsInfo = Object.assign({}, this.$store.getters.selectedWsInfo, JSON.parse(result))
      this.$store.commit('setSelectedWsInfo', selectedWsInfo)
      // notify(this, 'Success', this.$t('updateSuccess'), 'success')

      this.isMagicLinkLoading = false
    },
    async createMagicLink() {
      // TODO: 어떻게 쓸지 몰라서 일단은...
      // TODO: 나중에 함수 통합 필요

      let title = format(this.$t('magicLinkTitle'), [this.passedWsName])
      let content = format(this.$t('magicLinkContent'), [
        this.userInfo.userDisplayName || this.userInfo.userFullName,
        this.passedWsName,
      ])
      let imgUrl = this.passedWsLogo ?? 'https://tape.ooo/img/tape_og_img.png'

      let setMagicLinkResult = await setMagicLink(this, this.passedWsId)
      let linkUrl =
        location.origin + '/invite?passedWsId=' + this.passedWsId + '&magicLinkCode=' + setMagicLinkResult.magicLinkCode

      let getInviteUrlResult = await getInviteUrl(this, title, content, imgUrl, linkUrl)

      return getInviteUrlResult.shortLink
    },
    async copy(url) {
      let copyResult = await copy(url)
      if (copyResult) {
        if (!this.isMobile()) {
          // notify(this, 'Success', this.$t('copiedClipboardUrl'), 'success')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('copiedClipboardUrl'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
        }
        // TODO: analytics 추가
        // this.$analytics.logEvent('', { name: '', methodType: '' })
      } else {
        // notify(this, 'Error', this.$t('failedCopy'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('failedCopy'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      }
    },
  },
}
</script>
<style scoped></style>
